import React from "react";
import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CalendarDays } from "lucide-react";
import WaitingPatientCard from "../WaitingPatientCard/WaitingPatientCard";
import "./WaitingRoomColumn.css";

export default function WaitingRoomColumn({
  id,
  title,
  patients = [],
  count = 0,
  accentColor = "#006eea ",
  icon,
  emptyIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-days"><path d="M8 2v3"/><path d="M16 2v3"/><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M8 13h.01"/><path d="M12 13h.01"/><path d="M16 13h.01"/><path d="M8 17h.01"/><path d="M12 17h.01"/><path d="M16 17h.01"/></svg>,
  emptyText = "No appointments here",
  onRemovePatient,
  onAdvancePatient,
  onOpenPayment,
  onOpenPaymentHistory,
  onLoadPatientAppointments,
  onLoadPatientDetails,
  showOpenFile = true,
}) {
  const { setNodeRef, isOver } = useDroppable({ id });

  const isWaitingCol = id === "waiting";

  return (
    <section
      className={[
        "wrc",
        isOver ? "wrc--over" : "",
        patients.length === 0 ? "wrc--empty-column" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{ "--col-accent": accentColor }}
    >
      <header className="wrc__header">
        <div className="wrc__title-row">
          <span className="wrc__icon" aria-hidden="true">
            {icon}
          </span>

          <h3 className="wrc__title">{title}</h3>

          <span className="wrc__count">{count}</span>
        </div>

        <div className="wrc__accent-bar" />
      </header>

      <div
        ref={setNodeRef}
        className={[
          "wrc__body",
          isOver ? "wrc__body--over" : "",
          patients.length === 0 ? "wrc__body--empty" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <SortableContext
          items={patients.map((patient) => patient.id)}
          strategy={verticalListSortingStrategy}
        >
          {patients.length === 0 ? (
            <div className="wrc__empty">
              <span className="wrc__empty-icon">{emptyIcon}</span>
              <p>{emptyText}</p>
            </div>
          ) : (
            patients.map((patient, index) => {
              const isActiveConsultation = isWaitingCol && index === 0;
              const canDrag = id === "confirmed" || isActiveConsultation;

              return (
                <WaitingPatientCard
                  key={patient.id}
                  patient={patient}
                  onRemove={onRemovePatient}
                  onAdvance={onAdvancePatient}
                  inConsultation={isActiveConsultation}
                  onOpenPayment={() => onOpenPayment(patient)}
                  onOpenPaymentHistory={onOpenPaymentHistory}
                  onLoadPatientAppointments={onLoadPatientAppointments}
                  onLoadPatientDetails={onLoadPatientDetails}
                  showOpenFile={showOpenFile}
                  canDrag={canDrag}
                />
              );
            })
          )}
        </SortableContext>
      </div>
    </section>
  );
}